<template>
  <div>
    <div class="main-content card p-1" v-if="loader === 100">
      <div class="row">
        <div class="col-md-12">
          <label>ID da unidade</label>
          <input type="text" class="form-control" v-model="unidade.id"/>
        </div>
        <div class="col-md-12">
          <label>CNES</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="unidade.cnes" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" @click="getCnes">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <label>Nome</label>
          <input type="text" class="form-control" v-model="unidade.nome" id="nome"/>
        </div>
        <div class="col-md-12">
          <label>Nome fantasia</label>
          <input type="text" class="form-control" v-model="unidade.nome_fantasia" />
        </div>
        <div class="col-md-12">
          <label>Razão social</label>
          <input type="text" class="form-control" v-model="unidade.razao_social" />
        </div>
        <div class="col-md-6">
          <label>CNPJ da entidade</label>
          <input type="text" class="form-control" v-model="unidade.cnpj_entidade" v-mask="'99.999.999/9999.99'"/>
        </div>
        <div class="col-md-6">
          <label>CNPJ da unidade</label>
          <input type="text" class="form-control" v-model="unidade.cnpj_unidade" v-mask="'99.999.999/9999.99'"/>
        </div>
        <div class="col-md-6">
          <label>Tipo de unidade</label>
          <v-select v-model="unidade.tipo_unidade" :options="tipo_unidade" :label="'nome'"
            :reduce="(tipo_unidade) => tipo_unidade.id" class="vselect"
          />
        </div>
        <div class="col-md-6">
          <label>Tipo da gestão</label>
          <v-select v-model="unidade.tipo_gestao" :options="tipo_gestao" :label="'nome'"
            :reduce="(tipo_gestao) => tipo_gestao.id" class="vselect"
          />
        </div>
        <div class="col-md-3">
          <label>CEP</label>
          <div class="input-group">
            <input type="text" class="form-control" v-model="unidade.cep" v-mask="'99999-999'" />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button" @click="buscar">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <label>Logradouro</label>
          <input type="text" class="form-control" v-model="unidade.logradouro" />
        </div>
        <div class="col-md-2">
          <label>Número</label>
          <input type="text" class="form-control" v-model="unidade.numero" @blur="buscarCoordenadasAutomatico"/>
        </div>
        <div class="col-md-3">
          <label>Complemento</label>
          <input type="text" class="form-control" v-model="unidade.complemento" />
        </div>
        <div class="col-md-3">
          <label>Bairro</label>
          <input type="text" class="form-control" v-model="unidade.bairro" />
        </div>
        <div class="col-md-3">
          <label>Município</label>
          <input type="text" class="form-control" v-model="unidade.municipio" />
        </div>
        <div class="col-md-3">
          <label>Estado</label>
          <input type="text" class="form-control" v-model="unidade.uf" />
        </div>
        <div class="col-md-5">
          <label>
            Latitude
            <small v-if="buscandoCoordenadas" class="text-info">
              <i class="fas fa-spinner fa-spin"></i> Buscando...
            </small>
            <small v-else-if="unidade.lat" class="text-success">
              <i class="fas fa-check-circle"></i>
            </small>
          </label>
          <input type="text" class="form-control" v-model="unidade.lat" readonly />
        </div>
        <div class="col-md-5">
          <label>
            Longitude
            <small v-if="buscandoCoordenadas" class="text-info">
              <i class="fas fa-spinner fa-spin"></i> Buscando...
            </small>
            <small v-else-if="unidade.long" class="text-success">
              <i class="fas fa-check-circle"></i>
            </small>
          </label>
          <input type="text" class="form-control" v-model="unidade.long" readonly />
        </div>
        <div class="col-md-2">
          <label>&nbsp;</label>
          <button 
            class="btn btn-primary btn-block" 
            type="button" 
            @click="buscarCoordenadas()" 
            :disabled="buscandoCoordenadas"
            title="Buscar coordenadas manualmente"
          >
            <i class="fas fa-map-marker-alt" v-if="!buscandoCoordenadas"></i>
            <i class="fas fa-spinner fa-spin" v-else></i>
          </button>
        </div>
        <div class="col-md-12">
          <label>Telefone</label>
          <input type="text" class="form-control" v-model="unidade.telefone" />
        </div>
        <div class="col-md-12">
          <label>Email</label>
          <input type="text" class="form-control" v-model="unidade.email" />
        </div>
        <div class="col-md-12 mt-1" v-if="unidade.unidade_id_original">
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="ativo" v-model="unidade.ativo" />
            <label class="custom-control-label" for="ativo">Unidade ativa</label>
          </div>
        </div>
        <div class="col-md-12 text-right">
          <hr />
          <router-link to="/unidades" class="btn btn-back mr-1">
            <i class="fa fa-arrow-left"></i> Voltar
          </router-link>
          <button 
            type="button" 
            class="btn btn-add" 
            @click="save" 
            :disabled="salvando || buscandoCoordenadas"
          >
            <span v-if="!salvando && !buscandoCoordenadas">Salvar</span>
            <span v-else-if="buscandoCoordenadas">Buscando coordenadas...</span>
            <span v-else>Salvando...</span>
            <i class="fa fa-save" v-if="!salvando && !buscandoCoordenadas"></i>
            <i class="fas fa-spinner fa-spin" v-else></i>
          </button>
        </div>
      </div>
    </div>
    <div class="row justify-content-center mt-3" v-else>
      <div class="col-10 text-center">
        <div class="progress">
          <div
            class="progress-bar bg-primary"
            role="progressbar"
            :style="'width: ' + loader + '%;'"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <b style="font-size: 14pt">Carregando</b><br />
        <b style="font-size: 16pt; line-height: 12pt">{{ loader }}%</b>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      loader: 0,
      salvando: false,
      buscandoCoordenadas: false,
      unidade: [],
      unidade_id_original: 0,
      tipo_unidade: [
        {"id": 1,  "nome": "POSTO DE SAUDE" },
        {"id": 2,  "nome": "CENTRO DE SAUDE/UNIDADE BASICA" },
        {"id": 4,  "nome": "POLICLINICA" },
        {"id": 5,  "nome": "HOSPITAL GERAL" },
        {"id": 7,  "nome": "HOSPITAL ESPECIALIZADO" },
        {"id": 15, "nome": "UNIDADE MISTA" },
        {"id": 20, "nome": "PRONTO SOCORRO GERAL" },
        {"id": 21, "nome": "PRONTO SOCORRO ESPECIALIZADO" },
        {"id": 22, "nome": "CONSULTORIO ISOLADO" },
        {"id": 32, "nome": "UNIDADE MOVEL FLUVIAL" },
        {"id": 36, "nome": "CLINICA/CENTRO DE ESPECIALIDADE" },
        {"id": 39, "nome": "UNIDADE DE APOIO DIAGNOSE E TERAPIA (SADT ISOLADO)" },
        {"id": 40, "nome": "UNIDADE MOVEL TERRESTRE" },
        {"id": 42, "nome": "UNIDADE MOVEL DE NIVEL PRE-HOSPITALAR NA AREA DE URGENCIA" },
        {"id": 43, "nome": "FARMACIA" },
        {"id": 50, "nome": "UNIDADE DE VIGILANCIA EM SAUDE" },
        {"id": 60, "nome": "COOPERATIVA OU EMPRESA DE CESSAO DE TRABALHADORES NA SAUDE" },
        {"id": 61, "nome": "CENTRO DE PARTO NORMAL - ISOLADO" },
        {"id": 62, "nome": "HOSPITAL/DIA - ISOLADO" },
        {"id": 64, "nome": "CENTRAL DE REGULACAO DE SERVICOS DE SAUDE" },
        {"id": 67, "nome": "LABORATORIO CENTRAL DE SAUDE PUBLICA LACEN" },
        {"id": 68, "nome": "CENTRAL DE GESTAO EM SAUDE" },
        {"id": 69, "nome": "CENTRO DE ATENCAO HEMOTERAPIA E OU HEMATOLOGICA" },
        {"id": 70, "nome": "CENTRO DE ATENCAO PSICOSSOCIAL" },
        {"id": 71, "nome": "CENTRO DE APOIO A SAUDE DA FAMILIA" },
        {"id": 72, "nome": "UNIDADE DE ATENCAO A SAUDE INDIGENA" },
        {"id": 73, "nome": "PRONTO ATENDIMENTO" },
        {"id": 74, "nome": "POLO ACADEMIA DA SAUDE" },
        {"id": 75, "nome": "TELESSAUDE" },
        {"id": 76, "nome": "CENTRAL DE REGULACAO MEDICA DAS URGENCIAS" },
        {"id": 77, "nome": "SERVICO DE ATENCAO DOMICILIAR ISOLADO(HOME CARE)" },
        {"id": 78, "nome": "UNIDADE DE ATENCAO EM REGIME RESIDENCIAL" },
        {"id": 79, "nome": "OFICINA ORTOPEDICA" },
        {"id": 80, "nome": "LABORATORIO DE SAUDE PUBLICA" },
        {"id": 81, "nome": "CENTRAL DE REGULACAO DO ACESSO" },
        {"id": 82, "nome": "CENTRAL DE NOTIFICACAO,CAPTACAO E DISTRIB DE ORGAOS ESTADUAL" },
        {"id": 83, "nome": "POLO DE PREVENCAO DE DOENCAS E AGRAVOS E PROMOCAO DA SAUDE" },
        {"id": 84, "nome": "CENTRAL DE ABASTECIMENTO" },
        {"id": 85, "nome": "CENTRO DE IMUNIZACAO" }
      ],
      tipo_gestao: [
        {
          id: 1,
          nome: "Estadual",
        },
        {
          id: 2,
          nome: "Municipal"
        },
      ],
    };
  },
  computed: {},
  methods: {
    save: async function () {
      const self = this;
      
      self.salvando = true;

      if (!self.unidade.lat || !self.unidade.long) {
        await self.buscarCoordenadas(true);
      }

      let api = self.$store.state.api + "unidades";

      if (self.unidade.unidade_id_original) {
        api += "/" + self.unidade.unidade_id_original;
      }

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          self.salvando = false;
 
          this.$router.push("/unidades");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.salvando = false;
        });
    },
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      fd.append("tipo_unidade",    self.unidade.tipo_unidade     ? self.unidade.tipo_unidade     : "");
      fd.append("nome",            self.unidade.nome             ? self.unidade.nome             : "");
      fd.append("nome_fantasia",   self.unidade.nome_fantasia    ? self.unidade.nome_fantasia    : "");
      fd.append("razao_social",    self.unidade.razao_social     ? self.unidade.razao_social     : "");
      fd.append("cnes",            self.unidade.cnes             ? self.unidade.cnes             : "");
      fd.append("cnpj_entidade",   self.unidade.cnpj_entidade    ? self.unidade.cnpj_entidade    : "");
      fd.append("cnpj_unidade",    self.unidade.cnpj_unidade     ? self.unidade.cnpj_unidade     : "");
      fd.append("tipo_gestao",     self.unidade.tipo_gestao      ? self.unidade.tipo_gestao      : "");
      fd.append("cep",             self.unidade.cep              ? self.unidade.cep              : "");
      fd.append("logradouro",      self.unidade.logradouro       ? self.unidade.logradouro       : "");
      fd.append("numero",          self.unidade.numero           ? self.unidade.numero           : "");
      fd.append("bairro",          self.unidade.bairro           ? self.unidade.bairro           : "");
      fd.append("municipio",       self.unidade.municipio        ? self.unidade.municipio        : "");
      fd.append("uf",              self.unidade.uf               ? self.unidade.uf               : "");
      fd.append("lat",             self.unidade.lat              ? self.unidade.lat              : "");
      fd.append("long",            self.unidade.long             ? self.unidade.long             : "");
      fd.append("telefone",        self.unidade.telefone         ? self.unidade.telefone         : "");
      fd.append("email",           self.unidade.email            ? self.unidade.email            : "");
      fd.append("_method", "POST");

      if (self.unidade.unidade_id_original) {
        fd.append("ativo", self.unidade.ativo ? 1 : 0);
      }

      if(self.unidade.id)
      {
        fd.append("id", self.unidade.id);
      }

      if (self.unidade.unidade_id_original) {
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getunidade: function (id) {
      const self = this;
      const api = self.$store.state.api + "unidades/" + id;

      axios
        .get(api)
        .then((response) => {
          self.unidade = response.data.data[0];

          self.unidade.unidade_id_original = self.unidade.id

          self.setLoader(50);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    buscar: function () {
      const self = this;

      // self.$loading(true);

      self.unidade.logradouro = '';
      self.unidade.bairro     = '';
      self.unidade.municipio  = '';
      self.unidade.uf         = '';
      // self.unidade.push();

      if (/^[0-9]{5}-[0-9]{3}$/.test(self.unidade.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + self.unidade.cep + "/json/",
          function (endereco) {

            console.log(endereco)
            // self.$loading(false);

            if (endereco.erro) {
              self.endereco = {};
              $("#numero").focus();
              self.$message(null, "CEP não localizado", "error");
              return;
            }

            self.unidade.logradouro = endereco.logradouro;
            self.unidade.bairro     = endereco.bairro;
            self.unidade.municipio  = endereco.localidade;
            self.unidade.uf         = endereco.uf;
            self.unidade.push();
          }
        );
      }
    },
    getCnes: function() {
      const self = this;
      const api = self.$store.state.api + "get-cnes/" + self.unidade.cnes;
      // self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.unidade.nome            = response.data.nome_fantasia;
          self.unidade.nome_fantasia   = response.data.nome_fantasia;
          self.unidade.razao_social    = response.data.nome_razao_social;
          self.unidade.cnpj_entidade   = response.data.numero_cnpj;
          self.unidade.cnpj_entidade   = response.data.numero_cnpj_entidade;
          self.unidade.cnpj_unidade    = response.data.numero_cnpj_entidade;
          self.unidade.tipo_unidade    = response.data.codigo_tipo_unidade;
          self.unidade.tipo_gestao     = response.data.tipo_gestao === 'M' ? 2 : 1 ;
          self.unidade.cep             = response.data.codigo_cep_estabelecimento.replace(/(\d{5})(\d{3})/, "$1-$2");
          self.unidade.numero          = response.data.numero_estabelecimento;
          self.unidade.telefone        = response.data.numero_telefone_estabelecimento;
          self.unidade.email           = response.data.endereco_email_estabelecimento;

          self.unidade.push();
          self.buscar();
          // self.$loading(false);
          $('#nome').focus();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          // self.$loading(false);
        });
    },
    buscarCoordenadas: async function(silencioso = false) {
      const self = this;

      if (!self.unidade.logradouro || !self.unidade.numero || !self.unidade.municipio || !self.unidade.uf) {
        if (!silencioso) {
          self.$message(null, "Preencha o endereço completo (logradouro, número, município e UF) para buscar as coordenadas", "warning");
        }
        return;
      }

      self.buscandoCoordenadas = true;

      const endereco = `${self.unidade.numero} ${self.unidade.logradouro}, ${self.unidade.municipio}, ${self.unidade.uf}, Brasil`;
      
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(endereco)}&limit=1`;

      try {
        const response = await axios.get(url);
        
        if (response.data && response.data.length > 0) {
          const resultado = response.data[0];
          self.unidade.lat = resultado.lat;
          self.unidade.long = resultado.lon;
          
          if (!silencioso) {
            self.$message("Sucesso", "Coordenadas encontradas com sucesso!", "success");
          }
        } else {
          if (!silencioso) {
            self.$message(null, "Não foi possível encontrar as coordenadas para este endereço. Verifique se o endereço está correto.", "warning");
          }
        }
      } catch (error) {
        console.error("Erro ao buscar coordenadas:", error);
        if (!silencioso) {
          self.$message(null, "Erro ao buscar coordenadas. Tente novamente.", "error");
        }
      } finally {
        self.buscandoCoordenadas = false;
      }
    },
    buscarCoordenadasAutomatico: function() {
      const self = this;
      
      if (self.unidade.numero && !self.unidade.lat && !self.unidade.long) {
        if (self.unidade.logradouro && self.unidade.municipio && self.unidade.uf) {
          self.buscarCoordenadas(true);
        }
      }
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.setLoader(50);

    if (id) {
      self.getunidade(id);
    } else {
      self.setLoader(50);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}
.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}
.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>